import React from 'react';
import { ClientStatus, UploadType } from '@core/generated/gql-types';
import { getStatusStyles } from '@/utils/styles.util';
import FileUpload from '@/components/shared/FileUpload';

interface ClientHeaderProps {
  id: string;
  name: string;
  logoUrl?: string;
  status?: ClientStatus;
  onLogoUpdate?: (newLogoUrl: string) => void;
}

const ClientHeader: React.FC<ClientHeaderProps> = ({
  id,
  name,
  logoUrl,
  status,
  onLogoUpdate,
}) => {
  return (
    <div className="mb-6 flex items-center gap-4">
      <div className="h-16 w-16">
        <FileUpload
          onUploadComplete={onLogoUpdate || (() => {})}
          uploadType={UploadType.ClientLogo}
          className="h-full w-full"
          showPreview={true}
          previewClassName="w-16 h-16 rounded-full overflow-hidden"
          objectId={id}
        >
          <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-gray-100">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={name}
                className="h-14 w-14 object-contain"
              />
            ) : (
              <div className="h-14 w-14 rounded-full bg-gray-200" />
            )}
          </div>
        </FileUpload>
      </div>
      <div>
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-gray-800">{name}</h1>
          <span
            className={`rounded-full px-2 py-1 text-xs font-semibold ${getStatusStyles(status)}`}
          >
            {status}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClientHeader;
